import { api } from '../instance';
export const trackVisitor = (trackVisitorDto) => {
    return api.post('/analytics/track-visitor', trackVisitorDto);
};
//# sourceMappingURL=track-visitor.api.js.map